import React from 'react';

import SiteMeta from "../components/SiteMeta";

const MainMenu = ({ menuOpen, setMenuOpen, url }: {menuOpen: boolean, setMenuOpen: (b:boolean) => void, url?: string}) => {
    let menuClass = "hidden";

    if (menuOpen === true) {
        menuClass = "h-screen";
    }

    const { menuLinks } = SiteMeta();
    return (
        <div className={menuClass}>
          <div onClick={() => setMenuOpen(false)} className="mainmenu-popup-links">
            {
              menuLinks ? menuLinks.map((item: any, key: number) => {
                return (<>
                    <a href={item.link} key={key}>{ item.pre ? <span className="sm">{item.pre} </span> : ""}{item.title}{ item.description ? <span className="sm"> {item.description}</span> : ""}</a>
                    {
                        item.links ?
                            <div className="sub-pages">
                                {
                                    item.links.map((subItem: any, subKey: number) => (
                                        <a href={subItem.link} key={subKey}>{subItem.title}</a>
                                    ))
                                }
                            </div>
                        : ""
                    }
                </>);
              }) : ""
            }
            {/*menuCenter.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
            {menuCenter.length > 0  && menuRight.length > 0 ? <hr /> : ""}
              {menuRight.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)*/}
          </div>
        </div>
    );
}

export default MainMenu;